export enum OrderRequestEnum {
  INSTANT = 1,
  FUTURE = 2
}
